<template>
  <div>
    <b-notification :has-icon="true" :icon="'info'" :closable="false">
      <strong>
        <span v-if="isSimulation">{{
          $t('compCarbonFormsSurveySummary.simulation-title')
        }}</span>
        <span v-else
          >{{ $t('compCarbonFormsSurveySummary.summary-title') }}
          {{ year }}</span
        >
      </strong>
      <br />
      <strong v-if="isSurvey">{{
        $t('compCarbonFormsSurveySummary.summary-1')
      }}</strong>
      <br v-if="isSurvey" />
      <span v-if="!isSimulation"
        >{{ $t('compCarbonFormsSurveySummary.position') }}:
        {{ $t(survey.position) }}</span
      >
      <br v-if="!isSimulation" />
      {{ $t('compCarbonFormsSurveySummary.summary-2') }} :
      {{ survey.nWorkingDay }}
    </b-notification>
    <b-notification
      v-if="commutesActive && survey.sections.length > 0"
      :has-icon="true"
      :icon="'bicycle'"
      :closable="false"
    >
      {{ $t('compCarbonFormsSurveySummary.summary-3') }}
      {{ commuteDay1Summary }}
      <br />
      <span v-if="sections2.length > 0">
        {{ $t('compCarbonFormsSurveySummary.summary-4') }}
        {{ commuteDay2Summary }}
      </span>
      <span v-else>
        {{ $t('compCarbonFormsSurveySummary.summary-5') }}
      </span>
    </b-notification>
    <b-notification
      v-if="foodsActive && survey.meals.length > 0"
      :has-icon="true"
      :icon="'cutlery'"
      :closable="false"
    >
      <strong
        >{{ $t('compCarbonFormsSurveySummary.summary-7') }} ({{ nMeals }}
        {{ $t('meals') }})</strong
      >
      <br />
      <span v-if="!isSimulation">
        {{ survey.nCateringMeal }}
        {{ $t('compCarbonFormsSurveySummary.summary-6') }}
      </span>
      <br v-if="!isSimulation" />
      {{ foodSummary }}
    </b-notification>
    <covid-information v-if="isSurvey" :year="year" />
  </div>
</template>

<script>
export default {
  name: 'Summary',
  props: {
    survey: {
      type: Object,
      default: null
    },
    commutesActive: {
      type: Boolean,
      default: true
    },
    foodsActive: {
      type: Boolean,
      default: true
    },
    isSimulation: {
      type: Boolean,
      default: false
    },
    isSurvey: {
      type: Boolean,
      default: false
    },
    year: {
      type: Number,
      default: null
    }
  },
  components: {
    'covid-information': () =>
      import('@/components/carbon/forms/survey/CovidInformation.vue')
  },
  computed: {
    nMeals () {
      return this.survey.meals.reduce((accumulator, object) => {
        return parseInt(accumulator) + parseInt(object.amount)
      }, 0)
    },
    sections1 () {
      return this.survey.sections.filter((section) => !section.isDay2)
    },
    sections2 () {
      return this.survey.sections.filter((section) => section.isDay2)
    },
    foodSummary () {
      let label = ''
      for (let meal of this.survey.meals) {
        label += meal.amount + ' ' + this.$t(meal.type) + ', '
      }
      return label.slice(0, -2)
    },
    commuteDay1Summary () {
      let label = ''
      for (let section of this.survey.sections) {
        if (!section.isDay2) {
          label += section.distance + ' ' + this.$t('km-' + section.mode) + ', '
          if (section.mode === 'car') {
            label = label.slice(0, -2)
            label += ' (' + this.$t(section.engine) + '), '
          }
        }
      }
      return label.slice(0, -2)
    },
    commuteDay2Summary () {
      let label = ''
      for (let section of this.survey.sections) {
        if (section.isDay2) {
          label += section.distance + ' ' + this.$t('km-' + section.mode) + ', '
          if (section.mode === 'car') {
            label = label.slice(0, -2)
            label += ' (' + this.$t(section.engine) + '), '
          }
        }
      }
      return label.slice(0, -2)
    }
  }
}
</script>
